import { requests } from "api/HttpClient";

const { post, get, put, delete: deleteRequest } = requests;

const config = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

const contracts = {
  getAll: ({
    pageNumber = -1,
    pageSize = -1,
    maintenanceTypeId,
    companyId,
    assetId,
    searchParameter,
    facilityType,
    serviceType,
    status,
    orderBy,
    sortingOrder,
  }) => {
    let url = "/Contract/GetContractList";

    const queryParams = [];

    if (pageNumber && pageSize) {
      queryParams.push(`pageNumber=${pageNumber}`);
      queryParams.push(`pageSize=${pageSize}`);
    }

    if (searchParameter) {
      queryParams.push(`searchParameter=${searchParameter}`);
    }

    if (orderBy) {
      queryParams.push(`orderBy=${orderBy}`);
    }

    if (sortingOrder) {
      queryParams.push(`sortingOrder=${sortingOrder}`);
    }

    if (facilityType) {
      facilityType.forEach((type) => {
        queryParams.push(`FacilityType=${encodeURIComponent(type)}`);
      });
    }

    if (serviceType) {
      serviceType.forEach((serviceType) => {
        queryParams.push(`ServiceType=${encodeURIComponent(serviceType)}`);
      });
    }

    if (status) {
      status.forEach((status) => {
        queryParams.push(`Status=${encodeURIComponent(status)}`);
      });
    }

    if (maintenanceTypeId) {
      queryParams.push(`maintenanceTypeId=${maintenanceTypeId}`);
    }

    if (companyId) {
      queryParams.push(`externalCompanyId=${companyId}`);
    }

    if (assetId) {
      queryParams.push(`assetId=${assetId}`);
    }

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return get(url);
  },
  getById: (id) => get(`/Contract/GetContractById/${id}`),
  getContractTypeCount: () => get("Contract/GetContractTypeCount"),
  create: (data) => post("/Contract/AddContract", data, config),
  update: (id, data) => put(`/Contract/UpdateContract/${id}`, data, config),
  delete: (id) => deleteRequest(`/Contract/DeleteContract/${id}`),
};

export default contracts;
